import axios from "axios";

export default {
        endpoint: '/api/v2/',
        key: 'qrUvX2h7IpWkZivDDyvCZivDv2SPeD1Fjc98-1IIhx6OZ',
        token: '',
        workspace: {},
        me: {},
        version: 0,
        isDataUpdatingNow: false,
        socketURL: "",

        auth(){
            return new Promise((resolve, reject) => {
                this._request('auth', {
                    me: true,
                    socket: true
                }, 'POST')
                    .then((data) => {
                        resolve(data);
                    })
                    .catch(reject);
            });
        },

        updateData(){
            if(this.isDataUpdatingNow){
                return new Promise(((resolve, reject) => {reject()}))
            }
            this.isDataUpdatingNow = true;

            return new Promise((resolve, reject) => {
                this._request('data', {
                    v: this.version,
                    workspace_id: this.workspace.id
                })
                    .then(data => {
                        this.version = data.version;
                        resolve(data)
                    })
                    .catch(reject)
                    .finally(() => {
                        this.isDataUpdatingNow = false;
                    })
            });
        },

    requestWithAxios(path, data, method = 'GET'){
        return axios({
            method: method,
            url: this.endpoint + path,
            data: data,
            headers: {
                'x-api-key': this.key,
                'x-user-token': `${this.token}`
            }
        })
    },

        _request(path, params = {}, method = 'GET')
        {
            return new Promise((resolve, reject) => {

                let headers = { 'x-api-key': this.key };
                if(path !== 'auth'){
                    headers['x-user-token'] = `${this.token}`;
                }
                $.ajax({
                    type: method,
                    dataType: "json",
                    headers: headers,
                    url: `${this.endpoint}${path}`,
                    data: params,
                    success: (response) => {
                        //resolve(response);
                        this._checkResponse(response, resolve, reject);
                    },
                    fail: reject
                });

            })
        },
        _checkResponse(response, resolve, reject)
        {
            if(typeof response.status === 'undefined'){
                reject();
            } else if(response.status === 'ERROR'){
                if(typeof response.code !== 'undefined' && response.code === 421){
                    return;
                }

                this._error(response.error);
                //reject();
            } else {
                resolve(response)
            }
        },
        _error(message){
            $.oc.flashMsg({
                class: 'error',
                text: message
            })
        },
        init(callback){
            this.endpoint = `${document.location.protocol}//${document.location.host}${this.endpoint}`;
            this.auth().then((data) => {
                this.version = data.journal_version;
                this.me = data.me;
                this.workspace = data.me.workspace;
                this.token = data.token;
                this.socketURL = data.socketURL;
                callback()
            });
        }
};
